import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

export default {
  async setLookups({ commit, dispatch, state }, keys) {
    let _keys = keys.filter(k => !state.lookups[k])
    if (_keys.length) {
      const r = await startLoading(dispatch, 'setLookups', () =>
        http.post('lookup/ByKeys', keys)
      )
      commit(types.SET_LOOKUPS, [keys, r.data])
    }
  },
  async getLookupsByGroup({ commit, dispatch, state }, { className, group }) {
    const r = await startLoading(dispatch, 'getLookupsByGroup', () =>
      http.get(`lookup/ByGroup?className=${className}&group=${group}`)
    )
    commit(types.SET_GROUPS, r.data)
  },
  async getLookupValuesZeus({ commit, dispatch }, key) {
    const r = await startLoading(dispatch, 'getLookupValuesZeus', () =>
      http.get(`app/GetLookupValues?key=${key}`)
    )
    commit(types.SET_LOOKUPS_ZEUS, [key, r.data])
  },
  async getInsuranceCompanies({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getInsuranceCompanies', () =>
      http.get(`lookup/InsuranceCompanies`)
    )
    commit(types.SET_INSURANCE_COMPANIES, r.data)
  },
  async getOdometerUnits({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getOdometerUnits', () =>
      http.get(`serviceRequest/OdometerUnits`)
    )
    commit(types.SET_ODOMETERUNITS, r.data)
  },
  async getDamagePositions({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getDamagePositions', () =>
      http.get(`lookup/GetDamagePositions`)
    )
    commit(types.SET_DAMAGEPOSITIONS, r.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/actions.js